// Where a notification's target lives in the app. Kept in one place so the row,
// the bell popover and anything added later route identically.
//
// An unknown or absent target returns null, and the caller renders the row as
// non-clickable rather than navigating somewhere wrong — a notification is
// still worth reading even when we can't deep-link it.
export const targetPath = (target) => {
    if (!target?.type || target.id == null) return null

    switch (target.type) {
        case 'PERSON':
            return `/crm/people/${target.id}`
        // There is no /leads/:id route — the leads page is a list only — and a
        // Lead id is not a Person id, so the old `/crm/people/${id}` mapping
        // sent a lead straight to a 404. List page until a detail route exists.
        case 'LEAD':
            return '/leads'
        // Handled on the board by useOpportunityDeepLink: it highlights and
        // scrolls to the card rather than navigating off the pipeline.
        case 'OPPORTUNITY':
            return `/crm/pipeline?opportunity=${target.id}`
        case 'DEAL':
            return `/quotes/${target.id}`
        case 'LISTING':
            return `/listings/${target.id}`
        default:
            return null
    }
}

export const relativeTime = (iso) => {
    if (!iso) return ''
    const seconds = Math.floor((Date.now() - new Date(iso).getTime()) / 1000)
    if (seconds < 60) return 'just now'
    const minutes = Math.floor(seconds / 60)
    if (minutes < 60) return `${minutes}m`
    const hours = Math.floor(minutes / 60)
    if (hours < 24) return `${hours}h`
    const days = Math.floor(hours / 24)
    if (days < 7) return `${days}d`
    return new Date(iso).toLocaleDateString()
}
